import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface AddEstimatingSystemNoteInput {
    orderId: string;
    orderPartId: string;
    note: string;
}

const addEstimatingSystemNote = async (sessionId: string, input: AddEstimatingSystemNoteInput): Promise<void> => {
    await axios.patch(`${API_URL}/order/part/estimating-note`,
        input,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useAddEstimatingSystemNote = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: AddEstimatingSystemNoteInput) => addEstimatingSystemNote(sessionContext?.sessionId ?? '', input),
        onSuccess: (_, { orderId }) => {
            queryClient.invalidateQueries({ queryKey: ['/order/part'] });
            queryClient.invalidateQueries({ queryKey: ['/order/detail', orderId] });
            queryClient.invalidateQueries({ queryKey: ['/order/activity-logs', orderId] });
        }
    });
};
